import _ from "lodash";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Tooltip } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";
import { Info } from "@mui/icons-material";

export default function SelectInput({
    name,
    label,
    options,
    initialValue,
    required,
    helperText,
    sx,
    children,
    optionsToString,
    ...props
}) {
    if (options) {
        children = [];

        for (let index = 0; index < options.length; index++) {
            children.push(
                <MenuItem key={options[index]} value={options[index]}>
                    {optionsToString ? optionsToString[index] : options[index]}
                </MenuItem>
            );
        }
    }

    const labelId = _.uniqueId(name);

    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <FormControl required={required} error={hasError} variant="standard" sx={{ flex: 1 }}>
                            <InputLabel id={labelId}>
                                {label}
                                {props.tooltip &&
                                    <Tooltip title={props.tooltip}>
                                        <Info sx={{ marginLeft: 1 }} />
                                    </Tooltip>
                                }
                            </InputLabel>
                            <Select label={label} labelId={labelId} {...fieldProps.input} {...props}>
                                {children}
                            </Select>
                            <FormHelperText>{hasError ? fieldProps.meta.error : helperText}</FormHelperText>
                        </FormControl>
                    );
                }}
            </PField>
        </InputBox>
    );
}
